var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18696_43367",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18696_43367)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H32V24H0V0Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.667V16.667H32V14.667H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 18.333V20.333H32V18.333H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.33301V9.33301H32V7.33301H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 22V24H32V22H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11V13H32V11H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V2H32V0H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.66699V5.66699H32V3.66699H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 13,
    fill: "#2E42A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.72221 2.93822L0.996331 3.4471L1.2414 2.54149L0.59668 1.96758H1.43877L1.7212 1.22852L2.05237 1.96758H2.77022L2.20619 2.54149L2.42455 3.4471L1.72221 2.93822ZM5.72221 2.93822L4.99633 3.4471L5.2414 2.54149L4.59668 1.96758H5.43877L5.7212 1.22852L6.05237 1.96758H6.77022L6.20619 2.54149L6.42455 3.4471L5.72221 2.93822ZM8.99633 3.4471L9.72221 2.93822L10.4245 3.4471L10.2062 2.54149L10.7702 1.96758H10.0524L9.7212 1.22852L9.43877 1.96758H8.59668L9.2414 2.54149L8.99633 3.4471ZM13.7222 2.93822L12.9963 3.4471L13.2414 2.54149L12.5967 1.96758H13.4388L13.7212 1.22852L14.0524 1.96758H14.7702L14.2062 2.54149L14.4245 3.4471L13.7222 2.93822ZM0.996331 7.4471L1.72221 6.93822L2.42455 7.4471L2.20619 6.54149L2.77022 5.96758H2.05237L1.7212 5.22852L1.43877 5.96758H0.59668L1.2414 6.54149L0.996331 7.4471ZM5.72221 6.93822L4.99633 7.4471L5.2414 6.54149L4.59668 5.96758H5.43877L5.7212 5.22852L6.05237 5.96758H6.77022L6.20619 6.54149L6.42455 7.4471L5.72221 6.93822ZM8.99633 7.4471L9.72221 6.93822L10.4245 7.4471L10.2062 6.54149L10.7702 5.96758H10.0524L9.7212 5.22852L9.43877 5.96758H8.59668L9.2414 6.54149L8.99633 7.4471ZM13.7222 6.93822L12.9963 7.4471L13.2414 6.54149L12.5967 5.96758H13.4388L13.7212 5.22852L14.0524 5.96758H14.7702L14.2062 6.54149L14.4245 7.4471L13.7222 6.93822ZM0.996331 11.4471L1.72221 10.9382L2.42455 11.4471L2.20619 10.5415L2.77022 9.96758H2.05237L1.7212 9.22852L1.43877 9.96758H0.59668L1.2414 10.5415L0.996331 11.4471ZM5.72221 10.9382L4.99633 11.4471L5.2414 10.5415L4.59668 9.96758H5.43877L5.7212 9.22852L6.05237 9.96758H6.77022L6.20619 10.5415L6.42455 11.4471L5.72221 10.9382ZM8.99633 11.4471L9.72221 10.9382L10.4245 11.4471L10.2062 10.5415L10.7702 9.96758H10.0524L9.7212 9.22852L9.43877 9.96758H8.59668L9.2414 10.5415L8.99633 11.4471ZM13.7222 10.9382L12.9963 11.4471L13.2414 10.5415L12.5967 9.96758H13.4388L13.7212 9.22852L14.0524 9.96758H14.7702L14.2062 10.5415L14.4245 11.4471L13.7222 10.9382ZM16.9963 3.4471L17.7222 2.93822L18.4245 3.4471L18.2062 2.54149L18.7702 1.96758H18.0524L17.7212 1.22852L17.4388 1.96758H16.5967L17.2414 2.54149L16.9963 3.4471ZM17.7222 6.93822L16.9963 7.4471L17.2414 6.54149L16.5967 5.96758H17.4388L17.7212 5.22852L18.0524 5.96758H18.7702L18.2062 6.54149L18.4245 7.4471L17.7222 6.93822ZM16.9963 11.4471L17.7222 10.9382L18.4245 11.4471L18.2062 10.5415L18.7702 9.96758H18.0524L17.7212 9.22852L17.4388 9.96758H16.5967L17.2414 10.5415L16.9963 11.4471ZM3.72221 4.93822L2.99633 5.4471L3.2414 4.54149L2.59668 3.96758H3.43877L3.7212 3.22852L4.05237 3.96758H4.77022L4.20619 4.54149L4.42455 5.4471L3.72221 4.93822ZM6.99633 5.4471L7.72221 4.93822L8.42455 5.4471L8.20619 4.54149L8.77022 3.96758H8.05237L7.7212 3.22852L7.43877 3.96758H6.59668L7.2414 4.54149L6.99633 5.4471ZM11.7222 4.93822L10.9963 5.4471L11.2414 4.54149L10.5967 3.96758H11.4388L11.7212 3.22852L12.0524 3.96758H12.7702L12.2062 4.54149L12.4245 5.4471L11.7222 4.93822ZM2.99633 9.44711L3.72221 8.93822L4.42455 9.44711L4.20619 8.54149L4.77022 7.96758H4.05237L3.7212 7.22852L3.43877 7.96758H2.59668L3.2414 8.54149L2.99633 9.44711ZM7.72221 8.93822L6.99633 9.44711L7.2414 8.54149L6.59668 7.96758H7.43877L7.7212 7.22852L8.05237 7.96758H8.77022L8.20619 8.54149L8.42455 9.44711L7.72221 8.93822ZM10.9963 9.44711L11.7222 8.93822L12.4245 9.44711L12.2062 8.54149L12.7702 7.96758H12.0524L11.7212 7.22852L11.4388 7.96758H10.5967L11.2414 8.54149L10.9963 9.44711ZM15.7222 4.93822L14.9963 5.4471L15.2414 4.54149L14.5967 3.96758H15.4388L15.7212 3.22852L16.0524 3.96758H16.7702L16.2062 4.54149L16.4245 5.4471L15.7222 4.93822ZM14.9963 9.44711L15.7222 8.93822L16.4245 9.44711L16.2062 8.54149L16.7702 7.96758H16.0524L15.7212 7.22852L15.4388 7.96758H14.5967L15.2414 8.54149L14.9963 9.44711Z",
    fill: "#F7FCFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.2ae9eca65455ecc40bf56cfc68376d6e.svg";
export { ForwardRef as ReactComponent };